const errorsBus = useEventBus('errors')

export function useErrorsBus() {
  return { errorsBus }
}
